import { Button, Grid, Tooltip, type ButtonProps } from "../ui";
import type { ReactNode } from "react";
import { useOptionalAppTheme } from "../theme/useAppTheme";

/**
 * Aktion einer Zeile in Liste oder Tabelle (Entscheidung 13.10.2026): Symbol plus Text. Bei wenig Platz
 * — schmaler Bildschirm (unter `md`) oder ausdrücklich `compact` für schmale Aktionsspalten — nur das
 * Symbol; die übersetzte Beschriftung bleibt dann als Tooltip und zugänglicher Name erhalten. Themes mit
 * `listActions: "icon"` (z. B. Vital) zeigen immer nur das Symbol.
 */
export type ListIconActionProps = Omit<ButtonProps, "children" | "icon" | "aria-label" | "title" | "type"> & {
  icon: ReactNode;
  label: string;
  tooltip?: ReactNode;
  /** Nur Symbol, z. B. in einer schmalen Aktionsspalte mit mehreren Aktionen. */
  compact?: boolean;
};

export function ListIconAction({ icon, label, size = "small", tooltip, compact, ...buttonProps }: ListIconActionProps) {
  const screens = Grid.useBreakpoint();
  const themeIconOnly = useOptionalAppTheme()?.theme.listActions === "icon";
  const iconOnly = themeIconOnly || (compact ?? screens.md === false);
  if (!iconOnly) {
    const button = <Button {...buttonProps} type="text" size={size} icon={icon}>{label}</Button>;
    return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
  }
  return (
    <Tooltip title={tooltip ?? label}>
      <Button {...buttonProps} type="text" size={size} icon={icon} aria-label={label} />
    </Tooltip>
  );
}
